module.exports = __webpack_public_path__ + "static/media/house-bathroom.171df984.png";


//////////////////
// WEBPACK FOOTER
// ./src/house/house-bathroom.png
// module id = 193
// module chunks = 0